module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00037.ca6d8e56.jpg";